import * as navStyles from "../../../styles/layout/navigation-smartphone-nojs.module.scss";

import React, {Fragment} from "react";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import IconContainer from "../../shared/IconContainer";
import PolyLink from "../../shared/PolyLink";
import {faCircle} from "@fortawesome/free-regular-svg-icons";
import {getSiteURL} from "../../../utils/parsing";

const NavigationSmartphoneHtml = React.memo(function Navigation({
    menu, siteURL, color,
}) {

    const [index, setIndex] = React.useState(-1);
    siteURL = getSiteURL(siteURL)

    const getURL = (target, n1_slug, n2_slug) => {
        let URL = "";

        if (!target || target.type === "menu") {
            return URL;
        }
        if (target.type === "strapi") {
            URL += siteURL;
            if (n1_slug) {
                URL += n1_slug + "/";
            }
            if (n2_slug) {
                URL += n2_slug + "/";
            }
            return (URL += target.slug);
        }
        if (target.type === "strapi_events" || target.type === "strapi_news") {
            return siteURL + target.slug;
        }
        if (target.type === "external_link") {
            return target.uid;
        }
    };

    const n3_html = (n3, n1_slug, n2_slug) => {
        return (<div className={navStyles.n3Container}>
            {n3?.menu?.map((item, n3Index) => {
                const url = getURL(item.target_object, n1_slug, n2_slug);
                if (item.visible) {
                    return (<PolyLink
                        url={url}
                        name={item.label}
                        target="_blank"
                        key={n3Index + "n3"}
                        className={navStyles.n3PolyContainer}
                    >
                        <div className={navStyles.n3TextContainer}>
                            <div className={navStyles.n3IconContainer}>
                                <FontAwesomeIcon
                                    className={navStyles.n3Icon}
                                    icon={faCircle}
                                    color="var(--red-color)"
                                ></FontAwesomeIcon>
                            </div>
                            <span className={navStyles.n3Text}>{item.label}</span>
                        </div>
                    </PolyLink>);
                }
                return <Fragment key={n3Index + "n3"}/>;
            })}
        </div>);
    };

    const n2_html = (n2, n1_slug) => {
        return (<ul className={navStyles.n2UlContainer}>
            {n2?.menu?.map((item, n2Index) => {
                const url = getURL(item.target_object, n1_slug);
                if (item.visible) {
                    return (<li key={n2Index + "li n2"} className={navStyles.n2liContainer}>
                        <ul>
                            {color === "BLACK" && <PolyLink
                                className={navStyles.n2PolyBlackContainer}
                                url={url}
                                name={item.label}
                                target="_blank">
                                <div className={navStyles.n2LinkContainer}>
                                    <div className={navStyles.n2LinkBlackItemContainer}>
                                  <span className={`${navStyles.n2__font} uppercase`}>
                                    {item.label}
                                  </span>
                                    </div>
                                </div>
                            </PolyLink>}
                            {color !== "BLACK" && <PolyLink
                                className={navStyles.n2PolyRedContainer}
                                url={url}
                                name={item.label}
                                target="_blank">
                                <div className={navStyles.n2LinkContainer}>
                                    <div className={navStyles.n2LinkRedItemContainer}>
                                  <span className={navStyles.n2Text}>
                                    {item.label}
                                  </span>
                                    </div>
                                </div>
                            </PolyLink>}
                        </ul>
                        {item?.target_object?.menu?.length > 0 && (<li className={navStyles.n3LiContainer}>
                            {n3_html(item.target_object, n1_slug, item.slug)}
                        </li>)}
                    </li>);
                }
                return <Fragment key={n2Index + "n2"}/>;
            })}
        </ul>);
    };

    return (<ul className={navStyles.n1UlContainer}>
        {menu?.length > 0 && menu[0].items?.map((n1, n1Index) => {
            if (n1.visible) {
                const url = getURL(n1?.target_object);
                return (<Fragment key={n1Index + "n1"}>
                    <li key={n1Index + "li n1"} className={navStyles.n1LiContainer}>
                        <>
                            <PolyLink
                                url={url}
                                name={n1.label}
                                className={navStyles.n1PolyContainer}
                                target="_blank"
                            >
                                {color === "BLACK" && (<button /* un button et aussi un lien ?? */
                                    className={navStyles.n1TextContainerBlack}
                                    tabIndex="0"
                                    arial-label={n1.label}
                                    onClick={() => {
                                        setIndex(n1Index === index ? -1 : n1Index);
                                    }}
                                    onKeyDown={() => {
                                        setIndex(n1Index === index ? -1 : n1Index);
                                    }}
                                >
                                    <p className={navStyles.n1Text}>
                                        {n1.label}
                                    </p>
                                    {n1.target_object?.menu?.length > 0 && (<IconContainer
                                        icon={n1Index === index ? "ARROW_DOWN_SMALL" : "ARROW_RIGHT_SMALL"}
                                        color="WHITE"
                                        size={30}
                                    />)}
                                </button>)}
                                {color !== "BLACK" && (<button
                                    className={navStyles.n1TextContainerRed}
                                    tabIndex="0"
                                    arial-label={n1.label}
                                    onClick={() => {
                                        setIndex(n1Index === index ? -1 : n1Index);
                                    }}
                                    onKeyDown={() => {
                                        setIndex(n1Index === index ? -1 : n1Index);
                                    }}
                                >
                                    {n1Index === index && (<p className={navStyles.n1TextSelect}>
                                        {n1.label}
                                    </p>)}
                                    {n1Index !== index && (<p className={navStyles.n1Text}>
                                        {n1.label}
                                    </p>)}
                                    {n1.target_object?.menu?.length > 0 && (<IconContainer
                                        icon={n1Index === index ? "ARROW_DOWN_SMALL" : "ARROW_RIGHT_SMALL"}
                                        color="WHITE"
                                        size={30}
                                    />)}
                                </button>)}
                            </PolyLink>
                            <div className={navStyles.horizontalSeparation}></div>
                            {n1Index === index && n1.target_object?.menu?.length > 0 && (<div className={navStyles.n2}>
                                {n2_html(n1.target_object, n1.slug)}
                            </div>)}
                        </>
                    </li>
                </Fragment>);
            }
            return <Fragment key={n1Index + "n1"}/>;
        })}
    </ul>);
});

export default NavigationSmartphoneHtml;
